import { FC } from 'react';
import { Image } from '@chakra-ui/react';

import { StJudeLogo as Logo } from '../images';

interface StJudeProps {
  width: string;
}
export const StJude: FC<StJudeProps> = ({
  width,
}: StJudeProps): JSX.Element => (
  <Image w={width} src={Logo} alt="St. Jude Logo" title="St. Jude Logo" />
);
